const messages = {
  LoginRegister: {
    Index: {
      ImageAlt: 'Giftaid it logo',
      Heading: 'Make more of a difference with Swiftaid',
      Cta: 'Register for free',
    },
    Email: {
      DefaultScreenTitle: 'Enter your email to get started',
      InvalidEmailScreenTitle: 'Whoops! Please try again',
      DefaultSwiftySpeechText:
        'Gift Aid is a tax relief that lets UK charities claim an extra 25% on every eligible donation made by a UK taxpayer',
      InvalidEmailSwiftySpeechText:
        "Whoops! That email doesn't look quite right! Please try again",
      Label: 'Your personal email address',
      Button: 'Continue',
      ConfirmStatement: "By continuing, you are confirming you're a",
      UkTaxpayerLink: 'UK taxpayer',
      AgreeStatement: 'and agree to Swiftaid’s',
      Terms: 'Terms',
      And: 'and',
      Privacy: 'Privacy Policy',
      NoSwiftaidAccount: "Don't have a Swiftaid account?",
      SignUpHere: 'Sign up here',
      ThankYou: "Thank you! I've sent an email to",
      Header: 'Please check your email to continue',
      UseDiffEmail: 'Use a different email',
      CheckYourJunk:
        "Can't find the email? Please check your junk or spam folder 📁",
    },
    Details: {
      Eyebrow: 'Almost there',
      Header: 'Your name & address',
      SubHeader:
        'Your name and home address are used to add Gift Aid to donations. {learnMore}',
      LearnMore: 'Learn more',
      FirstName: 'First Name',
      FirstNamePlaceholder: 'e.g. Alex',
      LastName: 'Last Name',
      LastNamePlaceholder: 'e.g. Smith',
      Country: 'Country',
      Postcode: 'Postcode',
      ZipCodePostalCode: 'Zip/postal code',
      PostcodePlaceholder: 'e.g. SW1A 1AA',
      SelectAddress: 'Select your address',
      PostcodeNotFound:
        'This postcode could not be found, please enter your address manually below.',
      AddressLookupFailure:
        'An error occurred, please try again or enter your address manually below.',
      CannotFindMyAddress: 'I cannot find my address in the list',
      EnterAddressManually: 'Enter address manually',
      AddressLine1: 'Address line 1',
      AddressLine1Placeholder: 'Address line 1',
      AddressLine2: 'Address line 2',
      AddressLine2Placeholder: 'Address line 2 (optional)',
      Town: 'City/Town',
      TownPlaceholder: 'City or town',
      County: 'County',
      CountyPlaceholder: 'County',
      StateProvinceCounty: 'State/province/county',
      StateProvinceCountyPlaceholder: 'State, province or county',
      GenericFieldError: 'Whoops, there is an error above',
      Saving: 'Saving…',
      WhyModal: {
        Title: 'Why we ask for your name and address',
        Paragraphs: [
          'Your full name and home address appear on Gift Aid declarations that charities send to HMRC.',
          'We also use them to match donations made through platforms and charities linked to Swiftaid, so eligible giving is less likely to be missed.',
          'We only use these details for Gift Aid once you have authorised Swiftaid. You can update them any time in your account.',
        ],
      },
      ButtonLabels: {
        Postcode: {
          Active: 'Press enter to find your address from the postcode',
          Disabled: 'This button is disabled until you enter your postcode',
        },
        Details: {
          Disabled:
            'This button is disabled as your address is currently incomplete',
        },
      },
    },
    Declaration: {
      Header: 'Authorise Swiftaid',
      SubHeader:
        'Authorise Swiftaid to add Gift Aid to donations you make through any platform or charity linked to Swiftaid. {learnMore}',
      LearnMore: 'Learn more',
      WhatModal: {
        Title: 'What authorising Swiftaid means',
        Intro: 'When you authorise Swiftaid, you are letting Swiftaid:',
        Items: [
          'Create Gift Aid declarations for the charities and CASCs you give to.',
          'Add Gift Aid to donations that would otherwise get missed, for example contactless giving.',
        ],
        Scope:
          'This only covers charities and fundraising platforms that work with Swiftaid. You can deactivate authorisation from your dashboard at any time.',
      },
      DeclarationStatements: [
        {
          Icon: '📆',
          Title: 'Gift Aid Authorisation',
          Text: 'I authorise Swiftaid to make Gift Aid declarations on my behalf during this tax year.',
        },
        {
          Icon: '🇬🇧',
          Title: 'UK taxpayer status',
          Text: 'I am a UK taxpayer and wish to add Gift Aid automatically to donations I make to supported charities using Swiftaid.',
        },
        {
          Icon: '💸',
          Title: 'Paying enough tax',
          Text: 'If I pay less Income Tax and/or Capital Gains Tax than the amount of Gift Aid claimed on all of my donations in that tax year it is my responsibility to deactivate Swiftaid and pay any difference to HMRC.',
        },
        {
          Icon: '👤',
          Title: 'Keeping up to date',
          Text: 'I will keep all of my details including name and address up to date by logging in to my Swiftaid account.',
        },
        {
          Icon: '🗂️',
          Title: 'Self assessment',
          Text: 'If I pay Income Tax at the higher or additional rate and want to receive the additional tax relief due, I will include all of my Gift Aid donations on my Self-Assessment tax return or ask HM Revenue and Customs to adjust my tax code.',
        },
      ],
      Terms:
        'I agree with the above statements and have read and agree with Swiftaid’s {terms} and {privacy}.',
      ConfirmButton:
        'A button to confirm you have read and agree to these statements',
    },
    HowSwiftaidWorks: {
      LinkText: 'Learn how Swiftaid works',
      Header: 'How Swiftaid works',
      Para1:
        'Every year UK Charities miss out on over half a billion pounds in unclaimed Gift Aid, with your help we can fix this!',
      Para2:
        'Swiftaid works as a Gift Aid intermediary, helping charities claim Gift Aid on donations.',
      Para3:
        'As a UK taxpayer, you can add 25% to your contactless donations by signing up and linking your card to Swiftaid for free.',
      Para4:
        'Any charity that uses Swiftaid will then automatically receive Gift Aid every time you tap to donate 💳 ❤️',
      CloseButton: 'Close',
    },
    Footer: {
      Streeva: 'Streeva Ltd',
      Statement:
        'Registered in England & Wales (No. 09451226). Registered address: Carsize Barn, Cornwall, TR27 5EX, UK.',
      Terms: 'Terms',
      Privacy: 'Privacy',
      ContactSupport: 'Support',
      TermsModal: {
        Header: 'Terms & Conditions',
      },
      PrivacyModal: {
        Header: 'Privacy Policy',
      },
    },
    LoginHeading: 'Log in with your email',
    LoginLabel: 'Enter your email to continue',
  },
  // Dashboard UI copy: source of truth is bob/Swiftaid Giving Dashboard.html (PRD is behaviour-only).
  Dashboard: {
    Common: {
      NotSet: 'Not set',
    },
    LegalModal: {
      Loading: 'Loading…',
      LoadError: 'We could not load this document here.',
      ViewInNewWindow: 'View in a new window',
    },
    Shell: {
      Loading: 'Loading your data…',
      Menu: {
        Open: 'Open menu',
        Close: 'Close menu',
      },
      Nav: {
        Dashboard: 'Dashboard',
        Statements: 'Statements',
        Donations: 'Donations',
        ClaimTaxBack: 'Claim tax back',
        Account: 'Account',
        Support: 'Support',
        Logout: 'Log out',
        DashboardWithNotifications: 'Dashboard, {count} notifications',
        NewBadge: 'New',
        NewFeatureAria: 'New feature',
      },
      Alerts: {
        NoAccounts: {
          Aria: 'No linked accounts notification',
          Body: 'You have no linked accounts, ',
          Cta: 'add one in Account',
        },
        NoAuthorisation: {
          Aria: 'Gift Aid authorisation required',
          Body: 'Swiftaid is not authorised to process Gift Aid on your behalf, ',
          Cta: 'renew authorisation in Account',
        },
      },
      Topbar: {
        GuestName: 'there',
        Dashboard: {
          TitleWelcome: 'Welcome to Swiftaid, {name}.',
          TitleWelcomeBack: 'Welcome back, {name}.',
          SubtitlePaid: "Here's an overview of your charitable giving.",
        },
        Statements: {
          Title: 'Annual statements',
          Subtitle: 'View and download your annual summaries.',
        },
        Giving: {
          Title: 'Donations',
          Subtitle:
            'View all your donations in one place, whether Gift Aid was added by Swiftaid or by you.',
        },
        Account: {
          Title: 'Your account',
          Subtitle:
            'Your profile, Gift Aid authorisation, matching details, and plan.',
        },
        Support: {
          Title: 'Support',
          Subtitle: 'Get help or find answers quickly.',
        },
        ClaimTaxBack: {
          Title: 'Claim tax back',
          Subtitle: 'See if HMRC is holding money that belongs to you.',
        },
        Default: {
          Title: 'Swiftaid',
          Subtitle: 'Your giving dashboard',
        },
        AuthorisationChip: {
          Title: 'Swiftaid status',
          Active: 'Active',
          Inactive: 'Inactive',
          AriaActive: 'Swiftaid status is active. Open Account.',
          AriaInactive: 'Swiftaid status needs attention. Open Account.',
        },
      },
      Support: {
        Intro: 'Get help or find answers quickly.',
      },
    },
    Support: {
      HowCanWeHelp: 'How can we help?',
      CommonQuestions: 'Common questions',
      HelpCentre: { Title: 'Help centre', Sub: 'Guides, FAQs and how-tos' },
      Chat: { Title: 'Send us a message', Sub: 'Replies within 24 hours' },
      Email: { Title: 'Email support', Sub: 'support@swiftaid.co.uk' },
      Faq: {
        GiftAid: {
          Title: 'How does Gift Aid work?',
          Sub: 'Learn what Gift Aid is',
        },
        SwiftaidDeclarations: {
          Title: 'How does Swiftaid add Gift Aid to my donations?',
          Sub: 'Learn how Swiftaid creates declarations for you',
        },
        HigherRate: {
          Title: 'Can I claim extra tax back on Gift Aided donations?',
          Sub: 'Check what you could get back, then follow our guide to claim from HMRC',
        },
        PaidPlan: {
          Title: 'What do I get when I upgrade?',
          Sub: "See what's included when you upgrade",
        },
      },
      Toast: {
        HelpCentre: 'Opening help centre…',
        Chat: 'Opening chat…',
        Email: 'Opening email…',
        Faq: 'Opening FAQ…',
      },
    },
    Welcome: {
      Notification: {
        Title: 'Welcome to your new Swiftaid dashboard',
        Body: 'Take a quick tour to see where everything lives and how to get the most from your account.',
        Cta: 'Take a tour',
        Later: 'Dismiss',
        DismissAria: 'Dismiss welcome message',
      },
      Tour: {
        Progress: '{current} of {total}',
        Skip: 'Skip tour',
        Back: 'Back',
        Next: 'Next',
        Finish: 'Finish tour',
        NavigationPausedHint:
          'Navigation is paused during this tour. Use Next and Back to move around.',
        NavigationPausedHintMobile:
          'Menu navigation is paused during this tour. Use Next to continue.',
        Steps: {
          menu: {
            Title: 'Menu',
            Body: 'Use the menu to move around your dashboard. Tap Next and we will open it for you.',
          },
          dashboard: {
            Title: 'Dashboard',
            Body: 'Your home for notifications and anything that needs your attention.',
          },
          donations: {
            Title: 'Donations',
            Body: 'Upgrade your Swiftaid account to unlock full giving records and see all of your donations in one place.',
            PaidBody:
              'View all your donations in one place, whether Gift Aid was added by Swiftaid or by you.',
          },
          statements: {
            Title: 'Statements',
            Body: "At the end of each tax year, we'll send you a statement summarising the Gift Aid we've processed for you. You'll find it here.",
            PaidBody:
              'View and download your annual Gift Aid summaries for each tax year when they are ready.',
          },
          account: {
            Title: 'Account',
            Body: 'Update your details, manage emails and linked cards, renew Gift Aid authorisation, or close your account.',
          },
          support: {
            Title: 'Support',
            Body: 'Guides, FAQs, and ways to contact the team whenever you need help.',
          },
          'claim-tax-back': {
            Title: 'Claim tax back',
            Body: "Check if you could claim some of your tax back. It's free to check.",
            PaidBody:
              'A step-by-step guide to claiming extra tax relief on Gift Aided donations from HMRC.',
          },
          upgrade: {
            Title: 'Upgrade',
            Body: 'Unlock your full giving record, record donations made elsewhere, and download detailed summaries. Upgrade any time here.',
          },
        },
      },
    },
    Account: {
      Personal: {
        Heading: 'Personal details',
        Lead: 'Your name and home address for your Swiftaid account.',
        FullName: 'Name',
        Address: 'Address',
        Edit: 'Edit',
      },
      Login: {
        Heading: 'Login & security',
        SignInEmail: 'Sign-in email',
        Password: 'Password',
        GiftAidAuth: 'Gift Aid authorisation',
        Manage: 'Manage',
        Change: 'Change',
        Review: 'Review',
      },
      Plan: {
        Heading: 'Your plan',
        Active: 'Active',
        PerYear: '/ year',
        PerMonth: '/ month',
        RenewsOn: 'Renews on',
        EndsOn: 'Your service will end on',
        ManageSubscription: 'Manage subscription',
        FreeLead:
          "You're on Swiftaid's free plan. There is no subscription and we do not charge your card.",
        FreeIncludesLabel: 'Included on the free plan:',
        FreeIncludes: {
          0: 'Gift Aid authorisation and donation matching',
          1: 'Your latest statement summary',
        },
        FreeUpgradeHeading: 'Upgrade your Swiftaid account',
        FreeUpgradeNote:
          'Unlock your full giving record, record donations made elsewhere, and download detailed summaries for every tax year for £19.99 a year.',
        SummaryFree: 'Free plan',
        SummaryPaid: 'Paid plan · £19.99/year',
        Toast: {
          ManageError: 'Could not open the billing portal, please try again.',
        },
      },
      CloseAccount: {
        Cta: 'Close your account',
        Modal: {
          Title: 'Close your account?',
          Intro:
            'Deactivating keeps your account and history but stops Swiftaid. Deleting removes all your information permanently.',
          ChoiceLegend: 'What would you like to do?',
          Deactivate: {
            Title: 'Deactivate your account',
            Sub: 'Keep your details and giving history, but stop Swiftaid claiming Gift Aid on your donations. You can authorise Swiftaid again later.',
            AlreadyDeactivated: 'Swiftaid is already deactivated.',
          },
          Delete: {
            Title: 'Delete everything',
            Sub: 'Permanently close your account and remove all your information from Swiftaid. This cannot be undone.',
          },
          Continue: 'Continue',
          Cancel: 'Cancel',
        },
      },
    },
    Status: {
      Hero: {
        Title: 'Swiftaid authorisation',
        Body: "You've authorised Swiftaid to add Gift Aid to donations you make through any platform or charity linked to Swiftaid.",
        BodyInactive:
          'Swiftaid is not currently authorised to create Gift Aid declarations on donations you make to charity.',
        StatusLabel: 'Status',
        StatusActive: 'Active',
        StatusInactive: 'Inactive',
        AuthorisedVia: 'Authorised via',
        AuthorisedSince: 'Authorised since',
        TaxYear: 'Tax year',
        DeactivateCta: 'Deactivate Swiftaid',
        RenewCta: 'Authorise Swiftaid',
      },
      Allows: {
        Heading: 'What your authorisation allows',
        Intro: "While your authorisation is active, you're letting Swiftaid:",
        IntroInactive: "When you authorise Swiftaid, you're letting Swiftaid:",
        Items: {
          0: 'Create Gift Aid declarations for the charities and CASCs you give to.',
          1: 'Add Gift Aid to donations that would otherwise get missed, e.g. contactless.',
        },
        ScopeBold:
          'This only covers charities and fundraising platforms that work with Swiftaid.',
        ScopeRest:
          " Donations you make elsewhere won't appear in your Swiftaid account automatically.",
      },
      Recognition: {
        Title: 'How Swiftaid recognises your giving',
        BodyBefore:
          'We match donations to you using your email addresses and the cards you donate with. ',
        BodyBold:
          'The more we can recognise, the more Gift Aid we add, at no cost to you.',
        BodyAfter: ' Keep these up to date so no eligible donation is missed.',
      },
      Matching: {
        Heading: 'Gift Aid matching',
        Lead: 'We match donations to you using your name, home address, email addresses, and the cards you donate with. The more we can recognise, the more Gift Aid we add, at no cost to you. Keep these up to date so no eligible donation is missed.',
        AuthNote:
          'Swiftaid only uses these details for Gift Aid once you have authorised.',
        SummaryIdentityEmpty: 'Not set',
        SummaryEmailsEmpty: 'No emails linked',
        SummaryEmailsOne: '1 email',
        SummaryEmailsOther: '{count} emails',
        SummaryCardsEmpty: 'No cards linked',
        SummaryCardsOne: '1 card',
        SummaryCardsOther: '{count} cards',
      },
      Personal: {
        Heading: 'Your details',
        Lead: "Your name and home address are part of every Gift Aid declaration, and help us match donations to you. Keep them up to date so your Gift Aid isn't missed.",
        FullName: 'Name',
        HomeAddress: 'Home address',
        Edit: 'Edit',
      },
      Legal: {
        Heading: 'Legal & information',
        Lead: "Read Swiftaid's privacy policy and terms of service.",
        Privacy: 'Privacy policy',
        Terms: 'Terms of service',
        Footnote:
          'Swiftaid is a product of Streeva Ltd. HMRC Recognised · ISO 27001 certified.',
      },
      ManageModal: {
        Title: 'Deactivate Swiftaid',
        Intro:
          'This stops Swiftaid adding Gift Aid to donations on your behalf. Your authorisation can become active again if you donate and add Gift Aid through a partner platform, or when you authorise Swiftaid here.',
        Confirm: 'Deactivate Swiftaid',
        DeactivatedToast: 'Swiftaid deactivated ✓',
      },
      RenewModal: {
        Title: 'Authorise Swiftaid',
        Intro:
          'Please make sure all the details below are correct before you continue.',
        EditDetails: 'Edit your details',
        EditDetailsHeading: 'Edit your details',
        EditDetailsIntro:
          'Update your name and home address, then save to return to authorisation.',
        BackToAuthorisation: '← Back to authorisation',
        Submit: 'Continue',
        ActivatedToast: 'Swiftaid authorised ✓',
      },
      Authorisation: {
        Title: 'Your authorisation',
        Paragraph1:
          'I am a UK taxpayer and I understand that if the Gift Aid claimed on donations I make in this tax year is more than the tax I pay on my income and capital gains it will be my responsibility to pay the difference to HMRC.',
        AuthText:
          'I authorise Swiftaid to Gift Aid all my donations for this tax year including those made previously on which I have not opted to add Gift Aid. I wish this to also apply to the next tax year when this authorisation is given between 1 March and 5 April inclusive.',
        CheckboxLabel:
          "I agree with the above statements and have carefully read Swiftaid's {terms} and {privacy}.",
        TermsLinkText: 'Terms',
        PrivacyLinkText: 'Privacy Policy',
        ConfirmAria: 'Confirm you agree to the authorisation statements',
      },
      Emails: {
        Heading: 'Email addresses',
        Lead: 'We match Gift Aid to donations made from any of these addresses. Your primary address is used to log in and receive notifications',
        Primary: 'Primary',
        PrimarySub: 'Primary · used to log in',
        Add: '+ Add another email',
        SetPrimary: 'Set as primary',
        Delete: 'Delete',
        SetPrimaryAria: 'Set {email} as your primary email address',
        DeleteAria: 'Delete linked email address {email}',
        PrimarySetToast: 'Primary email updated ✓',
        PrimarySetFailed: 'Could not update primary email. Please try again',
        AddForm: {
          Title: 'Add an email address',
          Intro:
            'We will send a confirmation link to this address. The email is only added after you click the link.',
          Label: 'Email address',
          Placeholder: 'e.g. you@example.com',
          Submit: 'Add email',
          SubmitLoading: 'Adding…',
          Cancel: 'Cancel',
          Failure:
            'There was a problem sending the confirmation email. Please try again.',
          AlreadyLinked:
            'This email address is already linked to your account.',
          RequestErrorLead:
            'Something went wrong. We could not send a confirmation email for this address.',
          RequestErrorSupport:
            'Please contact our support team and we will help you from here:',
          SupportEmail: 'support@swiftaid.co.uk',
          SupportLinkAria: 'Email Swiftaid support at support@swiftaid.co.uk',
          SuccessPara1:
            'We have sent a confirmation link to {email}. Click the link in that email to add it to your Swiftaid account.',
          SuccessPara2:
            "If you don't see the email immediately, it may take a few minutes to arrive. Check your junk or spam folder if it is not in your inbox.",
          SuccessDismiss: 'Dismiss success message',
          DevLinkLabel: 'Local mock API:',
          DevLinkCta: 'Open verification link',
        },
        Pending: {
          Badge: 'Pending',
          Sub: 'Waiting for email confirmation',
          Resend: 'Resend email',
          ResendShort: 'Resend',
          Cancel: 'Cancel request',
          CancelShort: 'Cancel',
          ResendAria: 'Resend confirmation email to {email}',
          CancelAria: 'Cancel pending verification for {email}',
          ResentToast: 'Confirmation email resent to {email} ✓',
          CancelledToast: 'Verification request cancelled for {email}',
        },
      },
      DeleteLinkedModal: {
        Title: 'Remove linked account?',
        TitleEmail: 'Remove this email?',
        Intro: 'Please confirm you want to remove your {account}.',
        IntroEmail: 'Remove {email} from your linked email addresses?',
        EmailMatchingNote:
          'We can still match Gift Aid on past donations made from this address, even if you no longer use it.',
        Confirm: 'Remove',
        Cancel: 'Cancel',
      },
      Cards: {
        Heading: 'Cards for matching',
        NoticeBold: 'These cards are never charged.',
        NoticeRest:
          ' We use them only to recognise your donations and add Gift Aid. Your subscription is billed separately under Account → Your plan.',
        Empty: 'No cards linked yet.',
        Expires: 'Expires {date}',
        Expired: 'Expired',
        Active: 'Active',
        Remove: 'Remove',
        RemoveAria: 'Remove {brand} card ending {last4}',
        Footnote:
          'Cards are added automatically when you donate through integrated platforms like JustGiving.',
      },
    },
    Hint: {
      TriggerLabel: 'More information',
    },
    Toast: {
      UpgradeComplete: 'Upgrade complete!',
      UpgradeFailed:
        'Your payment was not completed and you have not been charged. Please try again.',
      TaxPackDownloaded: 'PDF downloaded ✓',
      TaxPackDownloadFailed: 'Could not download your PDF. Please try again',
      DonationSaved: 'Donation saved ✓',
    },
    Home: {
      Empty: {
        Title: 'Your donations will appear here',
        Body: 'When you give through Swiftaid or a platform linked to this email, your donations will show up here.',
      },
      TotalDonated: 'Total donated',
      GiftAid: 'Gift Aid',
      SummaryGateInline:
        'This is a summary only. To view and download your detailed summary here,',
      UpgradeCta: 'Upgrade',
      UpgradeLink: 'Upgrade',
      PaidPlanBadgeLabel: 'paid plan',
      Consolidation: {
        SectionHeading: 'All your giving, in one place',
        Title: 'Bring all your giving together',
        Body: 'Record donations made anywhere and keep all your giving and Gift Aid in one place.',
        Features: {
          0: 'Record donations made anywhere',
          1: 'One complete giving record',
          2: 'Detailed summaries for self-assessment',
        },
        FeatureClaimGuide:
          'A step-by-step guide to claiming tax back on Gift Aided donations',
      },
      ImpactHeading: 'Your giving impact',
      ImpactHeadingCurrentTaxYear: 'Your giving impact for current tax year',
      MetricDonated: 'Donated',
      MetricGiftAid: 'Gift Aid',
      MetricGiftAidSub: 'On your giving record',
      MetricCount: 'Donations',
      MetricThisTaxYear: 'This tax year',
      RecentDonationsHeading: 'Recent donations',
      RecentDonationsFreeGate:
        'Upgrade your Swiftaid account to view all your donations and download detailed summaries.',
      RecentDonationsFreeGateInline:
        'View all your donations and download detailed summaries.',
      RecentDonationsFreeGateOneMore:
        'You have 1 more donation in your history.',
      RecentDonationsFreeGateMore: '{count} more donations in your history.',
      RecentDonationsFreeGateAllShown:
        'View all your donations and download detailed summaries.',
      AddDonationCta: 'Record a donation',
      ViewGivingRecordCta: 'View all donations',
      SourceSwiftaid: 'Swiftaid',
      SourceYou: 'You',
      AddedByYou: 'Added by you',
    },
    DonationDetailModal: {
      Date: 'Date',
      Amount: 'Amount',
      GiftAid: 'Gift Aid',
      IncludedInClaimHeading: 'Claimed tax back',
      ClaimTaxBackClaimed: 'Claimed for {year}',
      ClaimTaxBackNa: 'N/A',
      GiftAidYes: 'Yes',
      GiftAidNa: 'N/A',
      Notes: 'Notes',
      NotesPlaceholder: 'e.g. Direct debit, collection plate, sponsorship',
      SaveNotes: 'Save note',
      NotesSaved: 'Note saved',
      NotesSaveFailed: 'Could not save your note. Please try again.',
      DeleteDonation: 'Delete donation',
      EditDonation: 'Edit donation',
      OccurrenceEditNote: 'Changes only apply to this donation.',
      SaveEdits: 'Save',
      Edited: 'Donation updated',
      EditFailed: 'Could not update this donation. Please try again.',
      DeleteConfirmIntro: 'Are you sure? This cannot be undone.',
      KeepDonation: 'Keep donation',
      ConfirmDelete: 'Yes, delete',
      Deleting: 'Deleting…',
      Deleted: 'Donation deleted',
      DeleteFailed: 'Could not delete this donation. Please try again.',
      Proof: {
        Heading: 'Proof of donation',
        View: 'View',
        Download: 'Download',
        DownloadNamed: 'Download {filename}',
        OpenFull: 'View full size: {filename}',
        PreviewClose: 'Close',
        ImageLabel: 'Image',
        PdfLabel: 'PDF document',
        FileLabel: 'Attachment',
      },
      RetrospectiveStatementNote:
        'This gift was added after your {year} statement was issued. It is not included in that statement’s totals.',
      SourceHeading: 'Where this donation came from',
      Source: {
        giftAidHunt: {
          Body: 'This donation was matched by Swiftaid ({method}) and added to your giving record under Added by you.',
        },
        swiftaid: {
          Title: 'Swiftaid',
          Body: 'This donation was processed through Swiftaid. Gift Aid was claimed on your behalf where eligible.',
        },
        contactless: {
          Title: 'Contactless',
          Body: 'This donation was made using contactless Gift Aid through Swiftaid.',
        },
        online: {
          Body: 'This donation was made through {platform} and processed by Swiftaid.',
        },
        manual: {
          Title: 'Added by you',
          Body: 'You recorded this donation for your own records.',
        },
        recurring: {
          Title: 'Recurring donation',
          Body: 'This donation was added from your {frequency} recurring donation to {charity}.',
          NextDonation: 'Next donation: {date}',
          ManageSeries: 'Manage recurring donation',
        },
      },
    },
    RecurringDonationModal: {
      Back: 'Back',
      Kind: 'Recurring donation',
      Started: 'Started',
      Stopped: 'Stopped',
      NextDonation: 'Next donation',
      LastDonation: 'Last donation',
      FinalDonation: 'Final donation',
      Ends: 'Ends',
      OccurrenceLimit: 'After {count} donations',
      GiftAid: 'Gift Aid',
      GiftAidYes: 'Yes',
      GiftAidNo: 'No',
      GiftAidExceptionExcludedOne: "1 past donation didn't include Gift Aid",
      GiftAidExceptionExcludedMany:
        "{count} past donations didn't include Gift Aid",
      GiftAidExceptionIncludedOne: '1 past donation included Gift Aid',
      GiftAidExceptionIncludedMany: '{count} past donations included Gift Aid',
      EditScheduleHint: 'Changes here affect your recurring schedule.',
      InactiveScheduleHint:
        'To change how often it repeats or when it ends, use Restart.',
      Notes: 'Notes',
      NotesEmpty: 'No notes added',
      Status: 'Status',
      StatusActive: 'Active',
      StatusStopped: 'Stopped',
      StatusCompleted: 'Completed',
      Edit: 'Edit',
      InactiveEditHint:
        'These changes will apply when you restart this recurring donation.',
      NextDateLabel: 'Next donation date',
      NextDateInPast: 'Please choose today or a later date',
      ApplyScopeLegend: 'Apply changes to',
      ApplyFuture: 'Future donations only',
      ApplyAll: 'All eligible donations from this schedule',
      ApplyAllHelp:
        'Donations you have edited individually will not be changed.',
      HistoryHeading: 'Donation history',
      HistoryCountOne: '1 donation',
      HistoryCountMany: '{count} donations',
      HistoryEmpty: 'No donations have been added from this schedule yet.',
      ShowMore: 'Show more',
      SkipNext: 'Skip next',
      SkipTitle: 'Skip next?',
      SkipConfirm:
        'Skip the donation due on {date}? It will not be added to your giving record. The schedule will continue afterwards.',
      SkipConfirmCta: 'Skip',
      Skipped: 'Next donation skipped',
      SkipFailed: 'Could not skip the next donation. Please try again.',
      Stop: 'Stop',
      StopTitle: 'Stop recurring donation?',
      StopConfirm:
        'No more donations will be added. Your existing donation history will stay as it is.',
      StopConfirmCta: 'Stop',
      StoppedToast: 'Recurring donation stopped',
      StopFailed: 'Could not stop this recurring donation. Please try again.',
      Restart: 'Restart',
      RestartTitle: 'Restart recurring donation',
      RestartIntro:
        'Confirm the future settings. Donations will not be added for the period while this recurring donation was stopped.',
      RestartCta: 'Restart',
      RestartedToast: 'Recurring donation restarted',
      RestartFailed:
        'Could not restart this recurring donation. Please try again.',
      Save: 'Save',
      Saved: 'Recurring donation updated',
      SaveFailed: 'Could not update this recurring donation. Please try again.',
      Delete: 'Delete',
      DeleteTitle: 'Delete recurring donation?',
      DeleteIntro:
        'This will permanently delete this recurring schedule and the {count} donations it added to your history.',
      DeleteIntroOne:
        'This will permanently delete this recurring schedule and the 1 donation it added to your history.',
      DeleteIntroEmpty:
        'This will permanently delete this recurring schedule. It has not added any donations to your history yet.',
      DeleteConfirmCta: 'Delete',
      Deleted: 'Recurring donation deleted',
      DeleteFailed:
        'Could not delete this recurring donation. Please try again.',
    },
    UpgradeModal: {
      Title: 'Keep all your giving in one place',
      Intro:
        'Record donations made anywhere. Use Swiftaid to keep your whole giving history in one place.',
      Features: {
        1: 'Record donations made anywhere',
        2: 'One complete giving record, every charity and every gift',
        3: 'Detailed summaries for self-assessment',
        4: "Access to previous years' summaries",
      },
      FeatureClaimGuide:
        'A step-by-step guide to claiming your tax back from HMRC, matched to how you pay tax',
      FeatureClaimGuideWithEstimate:
        'A step-by-step guide to claiming tax back from HMRC',
      PriceAmount: '£19.99',
      PricePeriod: 'per year',
      PriceDisplay: '£19.99 per year',
      ClaimCalloutLink: 'Not sure yet? See what you could get back, free',
      Cta: 'Upgrade now · £19.99 a year',
      StripeFooter:
        "You'll be charged £19.99 once a year · secured by Stripe · cancel renewal anytime",
      Checkout: {
        Title: 'Complete your payment',
        Intro:
          'Review your subscription below. In local mock mode this simulates the Stripe payment form.',
        MockBadge: 'Mock checkout · dev only',
        ProductName: 'Swiftaid',
        Or: 'or',
        PayCta: 'Pay £19.99',
        NameOnCard: 'Name on card',
        Country: 'Country',
        Back: 'Back',
        Processing: 'Preparing checkout…',
        LoadingPayment: 'Loading secure payment…',
        ErrorStart: 'Could not start checkout. Please try again.',
        ErrorPay: 'Payment could not be completed. Please try again.',
        ErrorName: 'Please enter the name on your card.',
        SubscriptionTerms:
          'By subscribing, you authorise Swiftaid to charge you according to the terms until you cancel.',
      },
      Success: {
        Title: "You're all set",
        Body: 'Your payment was successful and your paid plan is now active. It can take a moment for your plan to show as updated.',
        Done: 'Continue',
      },
    },
    ClaimTaxBack: {
      Checker: {
        Title: 'Check if you are owed money for {year}',
        Intro:
          'When you tick Gift Aid, the charity gets an extra 25% from HMRC. If you pay tax above the basic rate, you may also be able to claim some tax back yourself.',
        Start: 'Start the check',
        RegionLegend: 'Where did you pay tax?',
        RegionHelp:
          'Scotland has its own income tax rates. England, Wales and Northern Ireland share the same bands. Use where you were a taxpayer that year, not where you live now.',
        RegionRuk: 'England, Wales or NI',
        RegionScotland: 'Scotland',
        IncomeLegend: 'What was your income in {year}?',
        IncomeHelp: 'Before tax was taken.',
        GivingLabel: 'How much did you donate with Gift Aid?',
        GivingHelp:
          'Only donations where you added Gift Aid. An estimate is fine.',
        GivingPlaceholder: '0.00',
        Submit: 'Show me what I could get back',
        Duration: 'Takes 30 seconds',
        ErrorRegion: 'Please tell us where you paid tax.',
        ErrorBand: 'Please choose your income range.',
        ErrorAmount:
          'Please enter how much you gave under Gift Aid, for example 250.',
        ErrorAmountTooLarge: 'Please enter an amount up to £10,000,000.',
        ErrorSave:
          'Something went wrong saving your answers. Please try again.',
      },
      Result: {
        Eyebrow: 'Your estimate · {year}',
        Headline: 'You could claim up to:',
        WorkingHeading: 'How we worked this out',
        RowGiven: 'With Gift Aid added:',
        RowGross: 'Gift Aid makes it worth',
        RowRate: 'Your tax rate',
        RowClaimable: 'You could claim up to:',
        Explain:
          'The charities you donated to still get Gift Aid. This {amount} is separate money that HMRC may pay back to you, because you pay tax above the basic rate.',
        ClaimCta: 'Upgrade to claim',
        ClaimCtaBody: 'Get a step-by-step guide on how to make a claim.',
        UpsellTitle: 'Learn how to claim your tax back',
        UpsellBody:
          'Upgrade your account to get everything you need: check your Gift Aided donations are all here, then follow a step-by-step guide matched to how you pay tax.',
        ChangeAnswers: 'Change my answers',
      },
      NothingOwed: {
        Title: "There's nothing extra to claim",
        Body: 'You paid tax at the basic rate in {year}, so there is nothing extra for you to claim from HMRC. The charities you donated to still get Gift Aid.',
        RecordTitle: 'You can still keep a complete record of your giving',
        RecordBody:
          'Upgrading your Swiftaid account brings every charity and donation into one place, including ones made elsewhere, with a downloadable summary for each tax year.',
        RecordCta: 'See what’s included if I upgrade',
      },
      Guide: {
        Title: 'Your claim guide for {year}',
        Intro:
          'Tell us about your tax for {year}, build your claim, then contact HMRC. We will show you exactly what to do.',
        Metrics: {
          Aria: 'Your {year} claim figures',
          Given: 'Gift Aided donations',
          Claimable: 'You could claim up to:',
          ClaimablePending: 'Tell us about your tax below.',
          ClaimableNotYet: 'N/A',
          Count: 'Number of donations',
        },
        StepLabel: 'Step {number}',
        StepDone: 'Done',
        StepCollapse: 'Close this step',
        NothingOwed: {
          Title: "There's nothing extra to claim",
          Body: 'You paid tax at the basic rate in {year}, so there is nothing extra for you to claim from HMRC. The charities you donated to still get Gift Aid.',
        },
        Donations: {
          Title: 'Build your claim',
          Body: 'HMRC needs the total of your Gift Aided donations for {year}. We only know about donations made through Swiftaid, so add any that are missing, such as church collections or sponsorships. Only include donations where Gift Aid was added.',
          ViewAll: 'View or record more donations',
          Confirm: "That's all my Gift Aided donations",
          Skip: 'Skip this step',
          ZeroBody:
            'There are no Gift Aided donations in your account for {year} yet. Skip this step to see how to claim. Record any missing gifts before you contact HMRC, so the amount is right.',
          ErrorSave:
            'Something went wrong saving your confirmation. Please try again.',
          WaitingForTax: {
            Body: 'Finish telling us about your tax in step 1 and we will help you build your {year} claim.',
          },
          CompareShortfall:
            'In your initial check, you estimated around {estimate} in donations. Your Swiftaid account shows {account} so far. Check your donations and record anything missing. Donations without Gift Aid do not count.',
          CompareAhead:
            'This is higher than the {estimate} you estimated in your initial check, You can review your donation record before you claim.',
        },
        Tax: {
          Title: 'Your tax details',
          Body: 'Gift Aid tax relief is based on the tax year the donations were made in. Use your {year} details even if your income, address or how you pay tax has changed since.',
          FactRegion: 'Where you paid tax',
          FactIncome: 'Income before tax',
          FactPay: 'How you paid tax',
          MethodTaxReturn: 'Tax return',
          MethodBoth: 'PAYE and a tax return',
          MethodPaye: 'PAYE',
          Edit: 'Edit',
          Save: 'Continue',
          ErrorMissing:
            'Please choose where you paid tax, your income range, and how you paid income tax in {year}.',
          ErrorSave:
            'Something went wrong saving your details. Please try again.',
        },
        Pay: {
          Legend: 'How did you pay income tax?',
          Help: 'This is for {year}, and it decides how you claim.',
          Paye: 'PAYE',
          PayeDesc:
            'Tax is taken from your pay or pension. Most employees and pensioners.',
          TaxReturn: 'Tax return',
          TaxReturnDesc:
            'Self Assessment. You may not have sent the {year} return yet.',
          Both: 'Both',
          BothDesc:
            'Tax is taken from your pay or pension, and you also fill in a tax return.',
          NotSure: "I'm not sure",
          NotSureDesc: "We'll help you work it out.",
          NotSureHelp:
            'If tax is only taken from your pay or pension, choose PAYE. If you fill in a tax return, choose tax return or Both, even if tax also comes off your pay. If you are still unsure, HMRC can tell you which applies when you contact them.',
        },
        Route: {
          CopyWording: 'Copy wording',
          CopyAmount: 'Copy amount',
          CopyAmountAria: 'Copy {amount} to enter on your tax return',
          Copied: 'Copied',
          CopyFailed:
            'Could not copy. Please select the wording and copy it yourself.',
          PhoneHeading: 'Call HMRC on:',
          LetterHeading: 'Prepare your letter',
          LetterFilledName: 'Name and address',
          LetterFilledNameMissing:
            'Add your name and address before you download, so the letter is from you.',
          LetterFilledGiving: 'Gift Aided donations for {year}',
          LetterFilledList: 'Schedule of Gift Aided donations',
          LetterFilledListHelp:
            'This list is enclosed so HMRC can see how the claim is made up.',
          LetterFilledListHelpRequired:
            'HMRC requires every Gift Aided donation to be listed when the total is £10,000 or more. We have filled this in from your account.',
          LetterAddNi: 'National Insurance number',
          LetterAddNiHelp:
            "Include your National Insurance number so HMRC can identify your tax record. It's on your National Insurance card, benefit letter, payslip or P60. For example, QQ 12 34 56 C. We only use this to fill the letter. It is not saved on your account.",
          LetterAddNiPlaceholder: 'QQ 12 34 56 C',
          LetterAddNiError:
            'Enter a National Insurance number in the correct format',
          LetterDownloadTitle: 'Download your letter',
          LetterDownloadHelp:
            'Download the letter, print every page, sign it in the space above your name and post it.',
          LetterPostHeading: 'Post it to:',
          LetterAfterPost:
            'Keep a copy of the letter you post. HMRC usually replies within a few weeks. If you have not heard back, call them on {phone}.',
          LetterCheckDetails: 'Update name or address',
          LetterDownloadPdf: 'Download letter (PDF)',
          LetterDownloadWord: 'Download letter (Word)',
          LetterDownloadFailed:
            'Could not prepare the letter. Please try again.',
          Rate: {
            basic: 'basic rate',
            intermediate: 'intermediate rate',
            higher: 'higher rate',
            additional: 'additional rate',
            advanced: 'advanced rate',
            top: 'top rate',
          },
          Unknown: {
            Title: 'How to contact HMRC',
            Body: 'Answer how you pay income tax in step 1 and we will show the right way to claim for your situation.',
          },
          WaitingForDonations: {
            Body: 'Finish building your claim in step 2 and we will show you exactly what to tell HMRC, using the Gift Aided donations in your account.',
          },
          ZeroGivingNotice:
            'Your Gift Aided donations total £0.00 so far. These steps show how you could claim. Record your donations before you contact HMRC.',
          SelfAssessment: {
            Title: 'Put it on your tax return',
            Intro:
              'Your Gift Aided donations in {year} totalled {amount}. You file a Self Assessment return, so enter that figure on your {year} return, due 31 January {fileByYear}.',
            PreviewIntro:
              'You file a Self Assessment return. When you have recorded your Gift Aided donations, enter that total on your {year} return, due 31 January {fileByYear}.',
            Step1Title: 'Open Charitable giving',
            Step1Body:
              'On the paper return this is page TR 4. Online, look for Charitable giving.',
            Step2Title: 'Enter {amount} as Gift Aid payments made in the year',
            PreviewStep2Title:
              'Enter your Gift Aided donations as Gift Aid payments made in the year',
            Step2Body:
              'This is what you paid in {year}, not the total with Gift Aid added. HMRC works out the extra relief.',
            Step3Title: 'File by 31 January {fileByYear}',
            Step3Body:
              'Already filed {year}? You can amend the return until 31 January {amendByYear}.',
            AmountHeading: 'Enter this amount:',
          },
          RecordsTitle: 'Keep your donation records',
          // Two short lines; the detail sits behind a ? hint to keep step 3 light.
          RecordsKeep:
            'Keep your Gift Aid records until at least February {keepUntilYear}',
          RecordsKeepHintTrigger:
            'Why keep records until February {keepUntilYear}?',
          RecordsKeepHint:
            'HMRC asks for at least 22 months after the tax year ends, and may ask to see them. Your giving record has the dates, amounts and charities.',
          RecordsProof: 'Keep proof of your donations after you claim',
          RecordsProofHintTrigger: 'What counts as proof of a donation?',
          RecordsProofHint:
            'Receipts, thank you emails or bank statements. Swiftaid donations are already recorded, so this is for any you added yourself.',
          PayePhone: {
            Title: 'Call HMRC',
            Intro:
              'Your Gift Aided donations in {year} totalled {amount}. Claims of £5,000 or less can be made by phone.',
            PreviewIntro:
              'If your Gift Aided donations total £5,000 or less, you can claim by phone.',
            Step1Title: 'Call the income tax helpline',
            Step1Body:
              '{phone}, {hours}. Have your National Insurance number to hand.',
            Step2Title: 'Give them your Gift Aided donations',
            Step2Body:
              '{amount} in the {year} tax year: the amount you actually paid under Gift Aid. Tell them you pay tax at the {rate}.',
            PreviewStep2Body:
              'Tell them the amount you actually paid under Gift Aid in the {year} tax year, and that you pay tax at the {rate}.',
            Step3Title: 'Ask how they will pay you',
            Step3Body:
              'Ask them to confirm whether they will repay you or change your tax code. HMRC decides which, not you.',
            ScriptLabel: 'What to say on the call',
            Script:
              'I pay Income Tax at the {rate}. In the {year} tax year I made qualifying Gift Aid donations totalling {amount}. Please apply the tax relief due at the {rate} and issue any repayment owed to me.',
          },
          PayeWriting: {
            Title: 'Post a letter to HMRC',
            Intro:
              'Your Gift Aided donations total over £5,000, so HMRC will not take this claim by phone. We have filled in the letter from your account, with a schedule of your Gift Aided donations.',
            PreviewIntro:
              'If your Gift Aided donations total over £5,000, HMRC will not take the claim by phone. We will fill in a letter from your account once you have recorded your donations.',
          },
          PayeWritingItemised: {
            Title: 'Post a letter to HMRC',
            Intro:
              'Your Gift Aided donations total £10,000 or more, so HMRC will not take this claim by phone. We have filled in the letter from your account, with a schedule of your Gift Aided donations.',
            PreviewIntro:
              'If your Gift Aided donations total £10,000 or more, HMRC will not take the claim by phone. We will fill in a letter from your account once you have recorded your donations.',
          },
          ItemisedLink: 'Review donations',
        },
        Claimed: {
          Title: 'Have you sent this to HMRC?',
          Body: 'Once you have called, posted your letter, or put it on your tax return, mark this year as claimed. You can undo this if you marked it by mistake.',
          Mark: 'Mark as claimed',
          ErrorSave: 'Something went wrong saving that. Please try again.',
          DoneTitle: 'Marked as claimed',
          DoneBody:
            'You have marked {year} as claimed with HMRC. Gift Aided donations from that year are labelled in your giving record. If you record more, tell HMRC about those too, or undo this mark.',
          Undo: 'I have not sent this yet',
          Expand: 'View your claim',
          ViewDonations: 'View donations in this claim',
          Collapse: 'Hide claim steps',
          CollapsedIntro: 'You have marked {year} as claimed with HMRC.',
        },
        Faq: {
          Heading: 'Common questions',
          IsTaxAdvice: {
            Q: 'Is this tax advice?',
            A: 'No. Swiftaid provides general guidance to help you understand how Gift Aid tax relief works and how you may be able to claim it.\n\nWe do not provide personal tax or financial advice, and we cannot tell you what you should claim based on your individual circumstances.\n\nOur guidance is based on HMRC information. If you are unsure about your tax position or what you are entitled to claim, speak to HMRC, an accountant or a qualified tax adviser.',
          },
          WhyUpTo: {
            Q: 'Why does it say I could claim up to this amount?',
            A: 'The figure is an estimate based on the donations and tax details you have given us.\n\nHMRC uses your actual tax record to calculate the relief. They decide the final amount, which may be different.',
          },
          HowPaid: {
            Q: 'How does the money come back to me?',
            A: 'HMRC decides how to pay you. If you pay through PAYE they usually change your tax code, so you keep more of your pay for the rest of the year rather than receiving a payment. If you claim through a tax return, it comes off your bill or is repaid to you.',
          },
          WhyNetAmount: {
            Q: 'Why do I tell HMRC the amount I paid, not the total with Gift Aid?',
            A: 'Tell HMRC the total of your Gift Aided donations: the amount you actually paid. They add the 25% Gift Aid themselves and work out your relief from that full value. Gifts without Gift Aid do not go on the claim.',
          },
          KeepRecords: {
            Q: 'How long should I keep my donation records?',
            A: 'Keep your Gift Aid records for at least 22 months after the end of the relevant tax year. HMRC may ask to see them.\n\nYour records should show the date, the amount and the charity for each Gift Aided donation. Your giving record in Swiftaid holds this for you, so you can review it at any time.\n\nIt is also worth keeping proof of payment, such as receipts, thank you emails or bank statements, for any donations you recorded yourself.',
          },
          CharityImpact: {
            Q: 'Does claiming take anything away from the charities you donated to?',
            A: 'No. The charities you donated to still get Gift Aid. Your claim is separate money that HMRC pays back to you.',
          },
          EarlierYears: {
            Q: 'Can I claim for earlier years?',
            A: 'Yes, you can usually go back four years. This guide covers {year}. Mention any earlier years when you contact HMRC and they will tell you what they need.',
          },
        },
      },
      Disclaimer: 'This is general guidance, not personal tax advice.',
      ClaimableHintTrigger: 'How HMRC calculates this amount',
      ClaimableHint:
        'HMRC uses your actual tax record to calculate the relief.',
    },
    Giving: {
      Paywall: {
        Title: 'All your giving, in one place',
        Text: 'Record donations made elsewhere and keep all your giving and Gift Aid in one place.',
      },
      FilterLabel: 'Filter by tax year',
      FilterAll: 'All tax years',
      Loading: 'Loading donations',
      Updating: 'Updating donations',
      AddDonation: 'Record a donation',
      AddAnother: 'Record another donation',
      Views: {
        AriaLabel: 'Donations',
        History: 'Donation history',
        Recurring: 'Recurring donations',
      },
      Tabs: {
        AriaLabel: 'Donation views',
        // Visible label for the mobile select that replaces the tabs.
        FilterLabel: 'Show',
        All: 'All giving',
        Swiftaid: 'Added by Swiftaid',
        Manual: 'Added by you',
      },
      Metrics: {
        TotalGiving: 'Total giving',
        TotalGivingSubYear: 'This tax year',
        TotalGivingSubSelected: 'Tax year {year}',
        TotalGivingSubAll: 'All tax years',
        // Two different numbers share the word Gift Aid, so each card says
        // what it is. "With Gift Aid" is the slice of Total giving that had
        // Gift Aid added; "Gift Aid" is the extra amount that generated.
        GiftAid: 'Gift Aid',
        GiftAidSub: 'Added on top for charities, all tax years',
        GiftAidSubYear: 'Added on top for charities, this tax year',
        GiftAidSubSelected: 'Added on top for charities, tax year {year}',
        GiftAidedGiving: 'With Gift Aid',
        GivingPairAria: 'Total giving, and the amount given with Gift Aid',
        Charities: 'Charities supported',
        CharitiesSubYear: 'This tax year',
        CharitiesSubSelected: 'Tax year {year}',
        CharitiesSubAll: 'Across all years',
      },
      RecurringList: {
        Heading: 'Recurring donations',
        Count: '{count} recurring donations',
        Next: '{frequency} · Next {date}',
        Stopped: '{frequency} · Stopped {date}',
        Completed: '{frequency} · Completed {date}',
      },
      Table: {
        Date: 'Date',
        Charity: 'Charity',
        Amount: 'Amount',
        GiftAid: 'Gift Aid',
        NoGiftAid: 'No Gift Aid',
        Claimed: 'Claimed tax back',
        IncludedInClaimAria: 'Claimed tax back for {year}',
        Source: 'Source',
        Notes: 'Notes',
        Empty: 'No donations match this filter.',
        TotalLabel: 'Total giving',
        TotalNote: 'Includes all years',
        CaptionAll: 'All giving, all sources',
        CaptionSwiftaid: 'Added by Swiftaid',
        CaptionManual: 'Donations added by you',
      },
      AddDonationModal: {
        Title: 'Record a donation',
        Intro: 'Record a donation you made anywhere for your giving record.',
        KindLegend: 'What would you like to add?',
        KindSingleTitle: 'One-off donation',
        KindSingleShort: 'One-off',
        KindSingleBody: 'A donation you made once.',
        KindRecurringTitle: 'Recurring donation',
        KindRecurringShort: 'Recurring',
        KindRecurringBody: 'A donation that repeats on a schedule.',
        KindMissing: 'Please choose one-off or recurring',
        CharityLabel: 'Charity name',
        CharityPlaceholder: 'e.g. Local Hospice',
        DateLabel: 'Donation date',
        FirstDateLabel: 'First donation date',
        AmountLabel: 'Amount (£)',
        AmountPlaceholder: '0.00',
        RepeatsLabel: 'Repeats',
        FrequencyWeekly: 'Weekly',
        FrequencyMonthly: 'Monthly',
        FrequencyQuarterly: 'Quarterly',
        FrequencyAnnually: 'Annually',
        EndsLabel: 'Ends',
        EndUntilStopped: 'Until I stop it',
        EndOnDate: 'On a date',
        EndAfterOccurrences: 'After a number of occurrences',
        EndDateLabel: 'End date',
        OccurrenceCountLabel: 'Number of donations',
        NotesLabel: 'Notes (optional)',
        NotesPlaceholder: 'e.g. event name, fund',
        DateHint: 'Select a date',
        GiftAidChoice: {
          Legend: 'Gift Aid',
          Question: 'Was Gift Aid added to this donation?',
          RecurringQuestion: 'Was Gift Aid added to these donations?',
          YesOption: 'Yes, Gift Aid was added',
          NoOption: 'No, Gift Aid was not added',
          Note: "These are for your records only. Swiftaid can't claim Gift Aid on donations you add here.",
        },
        Save: 'Add donation',
        SaveRecurring: 'Add donations',
        PastDonationsOne: '1 past donation will be added',
        PastDonationsMany: '{count} past donations will be added',
        PastDonationsRange: 'From {from} to {to}.',
        BackfillConfirmTitle: 'Add {count} past donations?',
        BackfillConfirmBody:
          "We'll add the donations that have already happened. Future donations will be added as their dates arrive.",
        BackfillConfirmYears: 'These donations span {count} tax years.',
        BackfillConfirmCta: 'Add donations',
        BackfillGoBack: 'Go back',
        BackfillLimitTitle: 'This history is too large to add',
        BackfillLimitBody:
          'A recurring donation cannot create more than {limit} donations at once. Choose a later first donation date, a less frequent schedule, or an end date.',
        Toast: {
          Saved: 'Donation saved ✓',
          RecurringSaved: 'Recurring donation saved ✓',
          SaveFailed: 'Could not save your donation. Please try again',
          MissingCharity: 'Please enter a charity name',
          MissingDate: 'Please select a donation date',
          MissingFirstDate: 'Please select the first donation date',
          DateTooOld:
            "Donations older than 6 tax years can't be added. Please choose {date} or a later date.",
          MissingAmount: 'Please enter a valid amount',
          MissingGiftAid:
            'Please tell us whether Gift Aid was used on this donation',
          MissingEndDate: 'Please choose an end date',
          MissingOccurrenceCount: 'Please enter how many donations to add',
          InvalidEndDate:
            'The end date must be on or after the first donation date',
        },
      },
    },
    Notifications: {
      SectionHeading: 'Notifications',
      SectionCountAria: '{count} notifications',
      EmptyState: {
        Title: "You're up to date",
        Lead: 'Anything that needs your attention will show up here.',
      },
      SwiftaidStatus: {
        Title: 'Swiftaid status needs attention',
        BodyBoth:
          'Gift Aid authorisation is inactive and you have no linked giving accounts. Review your Swiftaid status to get back on track.',
        BodyNoAuthorisation:
          'Swiftaid is not authorised to process Gift Aid on your behalf. Renew your authorisation to keep claiming.',
        BodyNoAccounts:
          'You have no linked giving accounts. Add one so Swiftaid can recognise more of your donations.',
        Cta: 'Review in Account',
      },
      ClaimTaxBack: {
        Title: 'You could claim tax back',
        Body: 'You may be able to claim money back on your Gift Aid donations.',
        Cta: 'Check for free',
        DismissAria: 'Dismiss claim tax back notification',
        Paid: {
          Title: 'Some of your tax could come back to you',
          Body: 'If you pay tax above the basic rate and donate with Gift Aid, we can show you how to claim it from HMRC.',
          Cta: 'See how to claim',
        },
      },
    },
    GiftAidHunt: {
      PotentialGiftAid: 'Gift Aid available',
      SourcePill: 'Swiftaid',
      SourceTitle: 'Swiftaid',
      SourceBody:
        'This donation was sent to Swiftaid by the charity and it matched your details. Add Gift Aid to include it in your giving record.',
      Notification: {
        Title: 'Donations found for you',
        Body: '{count} charity donation(s) could have Gift Aid added. Review them now.',
        Cta: 'Review donations',
        Dismiss: 'Not now',
        DismissAria: 'Dismiss notification',
      },
      Wizard: {
        Eyebrow: 'The Great Gift Aid Hunt',
        Title: 'Add Gift Aid to this donation',
        Progress: '{current} of {total}',
        Decline: "Don't add Gift Aid",
        AddGiftAid: 'Add Gift Aid',
        CompleteTitle: 'Review complete',
        CompleteBody:
          'You added Gift Aid to {accepted} donation(s). They are now in your giving record.',
        CompleteUpgradeNote:
          'Upgrade your Swiftaid account to see your full giving record, detailed summaries, and PDF downloads.',
        Done: 'Done',
      },
      Toast: {
        QueueComplete: 'All donations reviewed ✓',
        ActionFailed: 'Something went wrong. Please try again',
      },
    },
    Donations: {
      Image: {
        HeartOverHand: 'An image of a heart floating above a hand,',
      },
      Not: {
        Title: 'Your donations will appear here',
        Sub: "You'll receive an email each time a new one arrives. Some donations can take up to 3 days to appear.",
      },
      SelectTaxYearLabel: 'Tax Year',
      Donated: 'Donated',
      GiftAid: 'Gift Aid',
      OrderBy: 'Order by',
      MostRecent: 'most recent',
      LeastRecent: 'least recent',
      Table: {
        EmptyMessage:
          'There are no donations to display for the selected tax year',
        Headings: {
          Donor: 'Your Donations',
        },
      },
      Summary: {
        Header: {
          Donated: 'Donated to charity',
          GiftAid: 'Added Gift Aid',
        },
      },
      DonationStatus: {
        Processing: 'Processing',
        Added: 'Added',
        OnHold: 'On hold',
        Cancelled: 'Cancelled',
        PendingCancellation: 'Pending cancellation',
      },
    },
    Statements: {
      AnnualSummaryHeading: 'Latest annual summary',
      Compliance: {
        TaxDetail:
          'If you paid less income tax and capital gains tax this year than the Gift Aid claimed on all your donations, you must pay any difference.',
      },
      Totals: {
        SwiftaidTitle: 'Annual Swiftaid statement',
        SwiftaidGiftAidedDonations: 'Gift Aided donations',
        SwiftaidMaximumGiftAid: 'Maximum Gift Aid',
        SwiftaidExclusion:
          'This total of {total} only includes donations processed through Swiftaid. It does not include gifts made through other donor intermediaries on your behalf, or donations given directly to charities. {giftAid} is the maximum amount of Gift Aid that charities can claim on these donations.',
        AddedTitle: 'Donations you added',
        AddedScope:
          'Not part of your Swiftaid statement. For your records only.',
        CombinedTotalsLabel: 'Combined totals',
        CombinedTotalsHintTrigger:
          'More information about these combined totals',
        CombinedTotalsHintBody:
          'These totals combine the amounts shown in {swiftaidPanel} and {addedPanel}.',
        CombinedGiftAidLabel: 'Total Gift Aid',
        AddedPanelTitle: 'Added by you',
      },
      ListIntro: {
        CombinedOne: '{count} donation amounting to {amount}',
        CombinedMany: '{count} donations amounting to {amount}',
        AddedOne: 'Including {count} donation you added amounting to {amount}',
        AddedMany:
          'Including {count} donations you added amounting to {amount}',
      },
      Historic: {
        heading: 'Historic years',
        subtitle: {
          free: 'Open any year to view it instantly when you upgrade',
          paid: 'Open any year to view details or download a detailed summary.',
        },
        free: {
          lockedTeaser: 'Earlier years are included when you upgrade.',
          unlockYears: 'Upgrade',
        },
      },
      NoDonationsInYear:
        'No donations were recorded for this tax year. If you gave during this period, they may still be processing or were made outside Swiftaid.',
      MoreDonations: 'Plus {count} more donations this year',
      DownloadPdf: 'Download PDF',
      TaxPackExport: {
        Title: 'Prepare your donation summary PDF',
        Intro: 'Choose the level of detail for your {year} PDF.',
        Downloading: 'Downloading…',
        DetailLegend: 'Level of detail',
        Basic: {
          Title: 'Basic',
          Sub: 'Totals and summary wording only.',
        },
        Detailed: {
          Title: 'Detailed',
          Sub: 'Itemised donation lists where applicable.',
        },
        Cancel: 'Cancel',
        Download: 'Download PDF',
      },
      TaxPackPrint: {
        Section1: {
          Title: 'Annual Gift Aid statement',
          Subtitle: 'Donations processed through Swiftaid',
          ItemisedHeading: 'Donations processed through Swiftaid',
        },
        Section2: {
          Title: 'Donations you have added yourself',
          Intro:
            'These donations were added by you for your own records. They have not been verified, processed, or submitted for Gift Aid by Swiftaid.',
          Total: 'Total donor-added donations',
        },
        Section3: {
          Title: 'Summary',
          SwiftaidRow: 'Added by Swiftaid',
          DonorAddedRow: 'Added by you',
          TotalRow: 'Total giving recorded',
          Disclaimer:
            'Donations added by you are included for record-keeping purposes only and have not been verified, processed or submitted for Gift Aid by Swiftaid.',
        },
        Table: {
          Charity: 'Charity',
          Date: 'Date',
          Source: 'Source',
          Amount: 'Amount',
          GiftAid: 'Gift Aid',
          GiftAidNa: '—',
        },
      },
      ViewDetail: 'View detail',
      HideDetail: 'Hide detail',
      ContactSupport: 'Contact support',
      Image: {
        Statement: 'An image of a mock statement,',
      },
      NotTitle: 'Annual statements',
      NotSub:
        "You'll receive a new statement at the end of each tax year. Use these to help with your tax return.",
      TableHeadings: {
        StatementYear: 'Statement year',
        TotalDonated: 'Total donated',
        GiftAid: 'Gift Aid',
      },
      FetchingStatements: 'Fetching statements',
      PrintButton: 'Print',
      Print: {
        Statement: 'Gift Aid statement',
        Donated: 'Total Donated',
        GiftAid: 'Maximum Gift Aid',
        Donor: 'Donor',
        DonorIntermediary: 'Donor Intermediary',
        Issued: 'Issued',
        Streeva: 'Streeva Ltd',
        Ref: 'Ref No',
        Summary:
          'This statement shows the value of donations made by you totalling £{totalDonated} over the tax year {taxYear} with a maximum amount of £{totalGiftAid} claimable as gift aid by charities.',
        Warning:
          'The total donated shown does not include anything given through other donor intermediaries on your behalf, or given by you directly to a charity.',
        Warning2:
          'If you paid less income tax and capital gains tax in this tax year than the amount of gift aid claimed by charities on all your donations, it is your responsibility to pay any difference.',
      },
    },
    Accounts: {
      AccountNotFoundError:
        'There was a problem finding this account, please try again',
    },
    Settings: {
      Auth: {
        Heading: 'Authorisation',
        IsAuth:
          'Swiftaid is authorised to process Gift Aid on your behalf until',
        IsAuthSub:
          'Click the button below to deactivate Swiftaid sooner. You can reactivate at any time.',
        NotAuth:
          'Swiftaid is not currently authorised to process Gift Aid on your behalf',
        NotAuthSub:
          'Click the button below to reactivate Swiftaid and automate Gift Aid',
        ButtonLabel:
          'By pressing this button authorisation to claim GiftAid will be cancelled from today',
      },
      RenewAuth: {
        Heading: 'Are the following details correct?',
        Lead: 'Please make sure all the details below are correct before you continue.',
        AddressLead:
          'Update your details below, then continue to your authorisation.',
        DeclarationLead:
          'Read the authorisation statements carefully. You must agree before Swiftaid can process Gift Aid on your behalf again.',
        BackToConfirm: 'Back to confirmation',
      },
      Cancellation: {
        Heading: 'Delete account',
        Text: 'Click the button below to close your Swiftaid account',
        Box: {
          Header: 'Are you sure?',
          Sub: 'Deleting your account will remove access to Swiftaid and will no longer process Gift Aid on your behalf.',
          Label: 'Type DELETE to confirm',
        },
      },
      DeleteSwiftaidAccountAriaLabel:
        'To close this account type delete in capital letters and press enter',
      DeletePlaceholder: 'DELETE',
      Email: {
        Heading: 'Account email address',
      },
      Personal: {
        Heading: 'Personal information',
        Details: 'Personal details',
        FullName: 'Name',
        Address: 'Address',
      },
    },
  },
  ManageAccount: {
    CloseAccount: {
      Header: 'Are you sure you want to close your Swiftaid account?',
      Lead: 'This will permanently close your account. You can create a new one later if you change your mind.',
      Confirm: 'Yes, close account',
      Cancel: 'No, keep my account',
      Closing: 'Closing…',
    },
    CloseAccountConfirm: {
      Header: 'All done',
      Para1: 'Your Swiftaid account has been closed.',
      Para2:
        'Please note: You may receive a Gift Aid statement at the end of the tax year, which we are legally obliged to send, if you made 2 or more donations totalling over £20. For full details on how your data is used and the reason behind it, please refer to our',
      Para2LinkText: 'Privacy Policy.',
      Button: 'Done',
    },
    Login: {
      Start: {
        CodeHeader: 'Sign in to Swiftaid',
        CodeParagraph:
          'Enter the email for your Swiftaid account and we’ll send you a one-time code.',
        MagicLinkHeader: 'Try a magic link',
        MagicLinkParagraph:
          'Enter the email for your Swiftaid account and we’ll send a unique link to continue.',
        TroubleSigningIn: 'Having trouble?',
        TroubleSigningInLinkText: 'Try a different method',
        SwitchToMagicLink: 'Try a magic link',
        SwitchToCode: 'Try a one-time code',
      },
      End: {
        Eyebrow: 'Check your inbox',
        Header: 'Enter your code',
        Paragraph:
          'We’ve sent a login code to {email}. Enter it below to continue.',
        MagicLinkHeader: 'Open the link we sent',
        MagicLinkParagraph:
          'We’ve sent a sign-in link to {email}. Open it to continue.',
        Note: 'If the email doesn’t arrive straight away, wait a minute and check your junk or spam folder.',
        NoteWithResend:
          'If the email doesn’t arrive straight away, wait a minute and check your junk or spam folder. {resend}',
      },
      EmailForm: {
        FieldLabel: 'Email address',
        // Escape @ — vue-i18n treats bare @ as linked-message syntax.
        FieldPlaceholder: "you{'@'}example.com",
        Button: {
          Text: 'Continue',
          LoadingText: 'Sending',
        },
      },
      CodeForm: {
        FieldLabel: 'One-time code',
        // Dot hint shows length without looking like a real code donors might type.
        FieldPlaceholder: '••••••',
        Button: {
          Text: 'Sign in',
          ContinueText: 'Continue',
          LoadingText: 'Signing in',
        },
      },
      Callback: {
        Title: 'Signing you in',
        Lead: 'Just a moment while we finish setting up your session.',
      },
    },
    Signup: {
      Steps: {
        Label: 'Account setup steps',
        Email: 'Email',
        Details: 'Details',
        Authorise: 'Authorisation',
        GoToDetailsAria: 'Go back to edit your name and address',
        Completed: 'Completed',
      },
      Start: {
        Eyebrow: 'Get started',
        CodeHeader: 'Create your Swiftaid account',
        CodeParagraph:
          'Enter your email and we’ll send a one-time code to verify it’s you.',
        MagicLinkHeader: 'Create your Swiftaid account',
        MagicLinkParagraph:
          'Enter your email and we’ll send a unique link to continue signup.',
        HaveAccount: 'Already have an account?',
        SignInHere: 'Sign in',
        TaxpayerCheckbox: 'I confirm I am a UK taxpayer.',
        LearnMore: 'Learn more',
        TaxpayerHint: 'Please confirm you are a UK taxpayer to continue.',
        TaxpayerModal: {
          Title: 'What we mean by UK taxpayer',
          Paragraphs: [
            'Gift Aid lets UK charities reclaim tax on eligible donations. To use Swiftaid you must pay enough UK Income Tax and/or Capital Gains Tax for the Gift Aid claimed on your donations.',
            'If you are not a UK taxpayer, Swiftaid is not the right service for you. Charities would not be able to claim Gift Aid on your donations.',
          ],
        },
      },
      End: {
        Eyebrow: 'Verify your email',
        Header: 'Enter your code',
        Paragraph:
          'We’ve sent a code to {email}. Enter it to continue setting up your account.',
        MagicLinkHeader: 'Open the link we sent',
        MagicLinkParagraph:
          'We’ve sent a signup link to {email}. Open it to continue.',
      },
    },
    UserNotFound: {
      Eyebrow: 'Whoops!',
      Header: 'We couldn’t find that account',
      Paragraph: 'We couldn’t find a Swiftaid account for',
      ParagraphWithEmail:
        'We couldn’t find a Swiftaid account for the email address entered.',
      Instruction:
        'Use the same email we use to send you messages and notifications, or create an account if you’re new.',
      Button: 'Try a different email',
      SignupCta: 'Create an account',
      SupportLead: 'Still stuck? We’re here to help.',
      ScheduledForDeletion: {
        Eyebrow: 'Whoops!',
        Header: 'Your account is scheduled for deletion',
        Paragraph:
          'The Swiftaid account for this email is scheduled to be deleted. You can cancel the deletion to keep your account, or log out.',
        CancelDeletion: 'Cancel deletion',
        Logout: 'Log out',
      },
    },
  },
  CookieConsent: {
    Title: 'Optional cookies',
    BodyBeforeLink:
      'We use optional cookies to keep Swiftaid secure and improve your experience. They stay off unless you accept. Read our ',
    PolicyLink: 'cookie policy',
    BodyAfterLink: ' for details.',
  },
  Accessibility: {
    Button: {
      Loading: 'Loading',
      Continue: 'Press enter to continue',
    },
    ErrorOccurred: 'An error has occurred, please try again',
  },
  Buttons: {
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    Close: 'Close',
    DeactivateSwift: 'Deactivate Swiftaid',
    RenewSwift: 'Renew authorisation',
    ConfirmDate: 'Confirm date',
    No: 'No',
    Yes: 'Yes',
    CloseAccount: 'Close account',
    Edit: 'Edit personal details',
    Continue: 'Continue',
    FindAddress: 'Find address',
    Save: 'Save',
    Agree: 'I agree',
    Logout: 'Log out',
    ResendLink: 'Resend link',
    ResendCode: 'Resend code',
    Resending: 'Resending...',
  },
  Menu: {
    Accounts: 'Linked accounts',
    Dashboard: 'Donations',
    Statements: 'Statements',
    Settings: 'Settings',
  },
  AxiosError: {
    BadRequest: 'Bad request, please try again',
    Unauthorised: 'You are unauthorised, please login again',
    Network: 'Unable to connect to server, please try again',
    NotFound: 'Sorry could not find this entry, please try again',
    Forbidden: 'Access denied please try again',
    Conflict: 'There was a conflict please try again',
    Server: 'A server error has occurred, please try again',
    ServiceUnavailable: 'Service unavailable, please check back soon.',
    Default:
      'An error has occurred, please try again or contact support for help',
  },
  AccountVerify: {
    HeaderVerifying: 'Confirming your email',
    HeaderSuccess: 'Email confirmed',
    HeaderFailure: 'We couldn’t confirm your email',
    Verifying: 'Just a moment while we confirm your email address…',
    Success:
      'Your email address has been confirmed and added to your Swiftaid account. You can close this window or return to your account.',
    SuccessCta: 'Go to account',
    Failure: 'Email confirmation failed',
    ErrorBadRequest: 'The confirmation code is invalid.',
    ErrorUnauthorized:
      'The verification code is not valid or has expired. Please try again.',
    ErrorNotFound: 'Something went wrong. Please try again.',
    ErrorConflict: 'Could not add this email to your account.',
    ErrorServer: 'A server error occurred. Please try again shortly.',
    Support: 'Need help? Reach us another way.',
  },
  NotFound: {
    Eyebrow: '404',
    Title: 'We cannot find that page',
    Lead: 'The address may be mistyped, or the page may have moved.',
    DashboardCta: 'Go to dashboard',
    LoginCta: 'Go to login',
    SupportLead: 'If you were looking for something else, we can still help.',
  },
  Maintenance: {
    Title: 'We’ll be back shortly',
    Lead: 'Swiftaid is undergoing scheduled maintenance. Please check back soon.',
    SupportLead: 'If you need help in the meantime, you can still reach us.',
  },
  AuthSupport: {
    NavLabel: 'Support options',
    HelpCentre: 'Help centre',
    Contact: 'Send a message',
  },
}

export type Messages = typeof messages
export default messages
